(function () {
  var section = document.querySelector(".product-recommendations");
  if (!section) return;

  if (section.querySelector(".rb-ymal:not(.rb-ymal--loading)")) {
    section.dataset.rbYmalLoaded = "true";
    if (typeof window.rbInitProductCardCarousels === "function") {
      window.rbInitProductCardCarousels(section);
    }
    return;
  }

  if (section.dataset.rbYmalLoaded === "true" || section.dataset.rbYmalLoading === "true") {
    return;
  }

  var excludedHandle = "navidium-shipping-protection";
  var maxProducts = 8;

  function initCarousel(root) {
    var target = root || section;
    if (typeof window.rbInitProductCardCarousels === "function") {
      window.rbInitProductCardCarousels(target);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.rbInitProductCardCarousels === "function") {
        clearInterval(timer);
        window.rbInitProductCardCarousels(target);
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function refreshYotpo() {
    if (window.yotpo && typeof window.yotpo.initWidgets === "function") {
      window.yotpo.initWidgets();
    }
  }

  function finishEmpty() {
    section.innerHTML = "";
    var wrapper = section.closest(".related_products");
    if (wrapper) wrapper.classList.add("is-empty");
    section.classList.remove("is-loading");
    section.dataset.rbYmalLoading = "false";
    section.dataset.rbYmalLoaded = "true";
  }

  function loadRecommendations() {
    var rawUrl = section.dataset.url;
    if (!rawUrl) return;

    section.dataset.rbYmalLoading = "true";
    section.classList.add("is-loading");

    var url = new URL(rawUrl, window.location.origin);
    url.searchParams.set("limit", String(maxProducts));

    fetch(url.toString(), { credentials: "same-origin" })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var tempWrapper = document.createElement("div");
        tempWrapper.innerHTML = text;
        var recommendations = tempWrapper.querySelector(".product-recommendations");

        if (!recommendations || !recommendations.innerHTML.trim().length) {
          finishEmpty();
          return;
        }

        var productCards = recommendations.querySelectorAll(".rb-product");
        var shownCount = 0;
        var seenHandles = {};

        Array.prototype.forEach.call(productCards, function (card) {
          var link = card.querySelector('a[href*="/products/"]');
          if (!link) return;

          var href = link.getAttribute("href");
          if (seenHandles[href]) {
            card.remove();
            return;
          }
          seenHandles[href] = true;

          var handle = href.split("/products/")[1].split(/[?#]/)[0];
          if (handle === excludedHandle || shownCount >= maxProducts) {
            card.remove();
            return;
          }
          shownCount += 1;
        });

        if (shownCount === 0) {
          finishEmpty();
          return;
        }

        section.innerHTML = recommendations.innerHTML;
        section.dataset.rbYmalLoaded = "true";
        section.classList.remove("is-loading");
        section.dataset.rbYmalLoading = "false";
        initCarousel(section);
        refreshYotpo();
      })
      .catch(function (error) {
        console.error("Error loading recommendations:", error);
        section.classList.remove("is-loading");
        section.dataset.rbYmalLoading = "false";
      });
  }

  // Start immediately — do not wait for scroll
  loadRecommendations();
})();
